module.exports = __webpack_public_path__ + "static/sponsorship_img-08-b@2x-9bccc03247c097bd76c17542676bf72c.jpg";